
const restaurantes = [
  {
    id: 1,
    name: 'O Mercado do Peixe',
    category: 'Peixe & Marisco',
    location: 'Machico',
    rating: 4.9,
    reviews: 312,
    priceRange: '€€',
    description: 'O melhor peixe fresco de Machico. Especialidade em espada preta com banana da Madeira e atum grelhado. Vista direta para o mar.',
    specialties: ['Espada com banana', 'Atum grelhado', 'Lapas grelhadas'],
    image: 'https://public.readdy.ai/ai/img_res/dacc5b80a1addc2c826b7ebcbe2978be.jpg',
    badge: 'A 5 min',
    badgeColor: 'bg-nature-green',
    distance: '5 min a pé',
  },
  {
    id: 2,
    name: 'Quinta do Sabor',
    category: 'Cozinha Madeirense',
    location: 'Machico',
    rating: 4.8,
    reviews: 245,
    priceRange: '€€',
    description: 'Ambiente rústico e acolhedor com receitas tradicionais da avó. Espetada de carne no espeto de louro, milho frito e bolo do caco acabado de fazer.',
    specialties: ['Espetada de carne', 'Milho frito', 'Bolo do caco'],
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Madeiran%20restaurant%20rustic%20interior%2C%20espetada%20meat%20skewer%20on%20laurel%20stick%2C%20corn%20fritters%2C%20bolo%20do%20caco%20bread%2C%20warm%20cozy%20atmosphere%2C%20wooden%20decor%2C%20authentic%20Portuguese%20food%2C%20family%20restaurant&width=600&height=400&seq=rest2&orientation=landscape',
    badge: 'Favorito Local',
    badgeColor: 'bg-amber-500',
    distance: '8 min a pé',
  },
  {
    id: 3,
    name: 'Miradouro do Caniçal',
    category: 'Vista Panorâmica',
    location: 'Caniçal',
    rating: 4.7,
    reviews: 189,
    priceRange: '€€€',
    description: 'Vista 360° sobre o oceano e a Ponta de São Lourenço. Perfeito para um jantar romântico ao pôr do sol. Carta de vinhos madeirenses excecional.',
    specialties: ['Bacalhau à Brás', 'Polvo grelhado', 'Vinho Madeira'],
    image: 'https://readdy.ai/api/search-image?query=Panoramic%20view%20restaurant%20Madeira%20island%20cliffs%2C%20romantic%20dinner%20table%20with%20ocean%20view%2C%20sunset%20over%20Atlantic%20ocean%2C%20elegant%20outdoor%20terrace%2C%20fine%20dining%2C%20candles%2C%20beautiful%20coastal%20scenery%2C%20luxury%20dining%20experience&width=600&height=400&seq=rest3&orientation=landscape',
    badge: 'Vista Incrível',
    badgeColor: 'bg-sea-blue',
    distance: '12 min de carro',
  },
  {
    id: 4,
    name: 'Café Central de Machico',
    category: 'Café & Pastelaria',
    location: 'Machico',
    rating: 4.6,
    reviews: 421,
    priceRange: '€',
    description: 'O ponto de encontro dos locais desde 1952. Poncha artesanal, pastel de nata quentinho e o melhor café da região. Ambiente autêntico e descontraído.',
    specialties: ['Poncha artesanal', 'Pastel de nata', 'Bica dupla'],
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Portuguese%20cafe%20Madeira%20island%2C%20cozy%20interior%20with%20vintage%20decor%2C%20pastel%20de%20nata%20pastries%2C%20espresso%20coffee%2C%20local%20people%2C%20warm%20atmosphere%2C%20authentic%20cafe%20culture%2C%20morning%20light%2C%20charming%20old%20building&width=600&height=400&seq=rest4&orientation=landscape',
    badge: 'Desde 1952',
    badgeColor: 'bg-rose-500',
    distance: '3 min a pé',
  },
  {
    id: 5,
    name: 'Taberna da Levada',
    category: 'Petiscos & Tapas',
    location: 'Machico',
    rating: 4.8,
    reviews: 178,
    priceRange: '€€',
    description: 'Petiscos modernos com ingredientes locais. Queijo da ilha, presunto da Madeira e uma seleção de vinhos regionais. Ideal para partilhar.',
    specialties: ['Queijo da ilha', 'Presunto da Madeira', 'Vinhos regionais'],
    image: 'https://readdy.ai/api/search-image?query=Modern%20tapas%20bar%20Madeira%20island%2C%20sharing%20plates%20with%20local%20cheese%20and%20cured%20meats%2C%20wine%20glasses%2C%20rustic%20chic%20interior%2C%20warm%20ambient%20lighting%2C%20social%20dining%2C%20artisan%20food%20presentation%2C%20cozy%20atmosphere&width=600&height=400&seq=rest5&orientation=landscape',
    badge: 'Novo',
    badgeColor: 'bg-nature-green',
    distance: '6 min a pé',
  },
  {
    id: 6,
    name: 'Restaurante Baía',
    category: 'Frutos do Mar',
    location: 'Machico',
    rating: 4.9,
    reviews: 356,
    priceRange: '€€€',
    description: 'Frente à baía de Machico, com terraço sobre a água. Marisco vivo, lagosta e percebes frescos. O lugar perfeito para celebrar momentos especiais.',
    specialties: ['Lagosta grelhada', 'Percebes', 'Marisco vivo'],
    image: 'https://readdy.ai/api/search-image?query=Seafood%20restaurant%20terrace%20over%20Machico%20bay%20Madeira%2C%20fresh%20lobster%20and%20shellfish%2C%20waterfront%20dining%2C%20elegant%20table%20setting%2C%20blue%20ocean%20view%2C%20sunset%20light%2C%20luxury%20seafood%20platter%2C%20romantic%20atmosphere&width=600&height=400&seq=rest6&orientation=landscape',
    badge: 'Premium',
    badgeColor: 'bg-amber-500',
    distance: '10 min a pé',
  },
];

const RestaurantesSection = () => {
  return (
    <section id="restaurantes" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-amber-600 text-xs font-semibold uppercase tracking-widest mb-3">Gastronomia Local</p>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4">
            Restaurantes <span className="font-serif italic text-amber-600">Recomendados</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed">
            Seleção pessoal dos melhores sabores de Machico e arredores. Da espada com banana ao marisco fresco — a gastronomia madeirense vai surpreendê-lo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {restaurantes.map((rest) => (
            <div
              key={rest.id}
              className="bg-white rounded-3xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group flex flex-col"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={rest.image}
                  alt={rest.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <span className={`absolute top-4 left-4 ${rest.badgeColor} text-white text-xs font-semibold px-3 py-1 rounded-full`}>
                  {rest.badge}
                </span>
                <span className="absolute top-4 right-4 bg-white/90 text-gray-800 text-xs font-bold px-2.5 py-1 rounded-full">
                  {rest.priceRange}
                </span>
              </div>

              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-start justify-between mb-1">
                  <h3 className="text-lg font-semibold text-gray-900">{rest.name}</h3>
                </div>
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-gray-500 bg-gray-100 px-2.5 py-0.5 rounded-full">{rest.category}</span>
                  <div className="flex items-center gap-1">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-amber-400 text-xs"></i>
                    </div>
                    <span className="text-sm font-semibold text-gray-800">{rest.rating}</span>
                    <span className="text-xs text-gray-400">({rest.reviews})</span>
                  </div>
                </div>

                <p className="text-gray-500 text-sm leading-relaxed mb-4 flex-1">{rest.description}</p>

                <div className="mb-4">
                  <p className="text-xs font-semibold text-gray-700 uppercase tracking-wide mb-2">Especialidades</p>
                  <div className="flex flex-wrap gap-2">
                    {rest.specialties.map((s, i) => (
                      <span key={i} className="text-xs bg-amber-50 text-amber-700 px-2.5 py-1 rounded-full border border-amber-100">
                        {s}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-1.5 text-sm text-gray-500">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-map-pin-line text-sea-blue"></i>
                    </div>
                    {rest.location} · {rest.distance}
                  </div>
                  <a
                    href={`https://www.google.com/maps/search/${encodeURIComponent(rest.name + ' ' + rest.location + ' Madeira')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-1 text-sm text-sea-blue font-medium hover:underline cursor-pointer whitespace-nowrap"
                  >
                    Ver no mapa
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-external-link-line"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RestaurantesSection;
